export enum EMPLOYEE_ACTIVE_FILTER {
  GET_ALL = 'GetAll',
  GET_ACTIVE = 'GetActive',
  GET_INACTIVE = 'GetInactive',
}
